<template>
  <div>
    <p v-if="cartFetching" class="text-center">
      <i class="el-icon-loading"></i>
    </p>
    <p v-else-if="!orders.length" class="text-center">{{ $t('No items selected') }}</p>
    <div class="product-list" :loading="orderSending">
      <div v-for="(orderLine, index) in orders" :key="index" class="product-item py-4">
        <h4 class="mt-0 mb-2">{{ orderLine.variant.product.data.name_english || orderLine.variant.product.data.name }}</h4>
        <div class="d-flex">
          <img v-if="orderLine.assets && orderLine.assets.filter(item => !['vimeo', 'youtube'].includes(item.kind)).length && orderLine.assets[0].primary" :src="orderLine.assets[0].thumbnail" />
          <img
            v-else-if="
              orderLine.variant.product.data.sources.assets &&
              orderLine.variant.product.data.sources.assets.thumbnail &&
              orderLine.variant.product.data.sources.assets.thumbnail.primary &&
              orderLine.variant.product.data.sources.assets.thumbnail.primary.link"
            :src="orderLine.variant.product.data.sources.assets.thumbnail.primary.link"
          />
          <img v-else src="https://www.placehold.it/400x235/EFEFEF/AAAAAA&text=No image" />
          <div class="list-option ml-4">
            <div v-for="(optionValue, optionKey) in orderLine.variant.options" :key="optionKey" class="option-item d-flex justify-content-end">
              <span class="text-capitalize" style="font-weight: bold">{{ optionKey }}: </span>
              <span class="text-primary ml-1">{{ optionValue.en }}</span>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center mt-2 mr-2">
          <span class="mr-2">{{ $t('Total') }}</span>
          <span class="total-money mr-1" style="max-width: 160px">
            {{ orderLine.variant.price * orderLine.quantity | yen }}
          </span>
          <el-input size="mini" v-model="orders[index].quantity" :disabled="true" class="input-number-custom">
            <el-button
              slot="prepend"
              icon="el-icon-minus"
              size="mini"
              :disabled="orderLine.variant.inventory_checking || viewMode === 'visitor'"
              @click="productNumberDown(orderLine)"
            ></el-button>
            <el-button
              slot="append"
              icon="el-icon-plus"
              size="mini"
              :disabled="viewMode === 'visitor'"
              :loading="orderLine.variant.inventory_checking"
              @click="productNumberUp(orderLine)"
            ></el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-space-between pt-2" style="border-top: 1px solid #ddd;">
      <span>{{ $t('Total amount') }}</span>
      <span>{{ totalAmount | yen }}</span>
    </div>
    <div v-if="viewMode === 'saler'" class="d-flex justify-content-space-between mt-4">
      <el-button
        type="warning"
        size="small"
        :disabled="!orders.length"
        plain
        style="width: 50%"
        @click="showConfirmCancellation()"
      >{{ $t('Cancel shopping cart') }}</el-button>
      <el-button
        type="primary"
        size="small"
        :disabled="!orders.length"
        style="width: 50%"
        @click="showConfirmOrder()"
      >{{ $t('Confirm order') }}</el-button>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Cart',
  props: {
    projectId: {
      type: Number
    },
    userConnected: {
      type: Object,
      default: null
    },
    sa: {
      type: Object,
      default: null
    },
    viewMode: {
      type: String,
      default: 'saler'
    }
  },
  computed: {
    ...mapGetters('preview', ['variant']),
    isSanboxMode () {
      return !!(this.sa && this.sa.sanbox) || (this.userConnected && this.userConnected.sanbox)
    }
  },
  data () {
    return {
      showConfirmCart: false,
      cartFetching: false,
      orderSending: false,
      orders: [],
      basket: {
        variants: []
      },
      basketLines: [],
      tempOrders: [],
      totalNumber: 0,
      totalAmount: 0
    }
  },
  methods: {
    ...mapActions('preview', ['changeVariantInventory', 'checkVariantInventory']),
    addProduct (data) {
      // data: { quantity: 1, variant: {} }
      let exist = this.orders.find((item) => item.variant.id === data.variant.id)
      if (exist) {
        let newQuantity = exist.quantity + data.quantity
        this.$set(exist, 'quantity', newQuantity)
        // this.updateBasketLine(newQuantity, exist.id)
      } else {
        this.orders.push(data)
        // this.createBasketLine(this.basket.id, [{quantity: data.quantity, id: data.variant.id}])
      }
      this.updateVariantInventory(data.variant.id, -data.quantity)
    },
    updateBasket (data) {
      let exist = this.basket.variants.find((item) => item.id === data.variant.id)
      if (exist) {
        let newQuantity = exist.quantity + data.quantity
        this.$set(exist, 'quantity', newQuantity)
        this.updateBasketLine(newQuantity, exist.id)
      } else {
        this.basket.variants.push({
          quantity: data.quantity,
          id: data.variant.id
        })
        setTimeout(() => {
          if (this.basket.id) {
            this.createBasketLine(this.basket.id, [{quantity: data.quantity, id: data.variant.id}])
          } else {
            this.submitBasket()
          }
        }, 100)
      }
    },
    removeProduct (data) {
      let index = this.orders.findIndex((item) => item.variant.id === data.variant.id)
      if (index !== -1) {
        this.orders.splice(index, 1)
      }
    },
    submitBasket () {
      axios.post(
        `${process.env.OLD_ECOMMERCE_URL}/baskets/create`,
        {
          project_id: this.projectId,
          contact_username: this.userConnected.username || this.userConnected.email,
          sa_email: this.sa.email || this.sa.username,
          store_id: this.sa.store_id || 1,
          store_email: (this.sa.store || {}).email || null,
          sa_user_id: this.sa.username,
          vip_user_id: this.userConnected.username,
          ...this.basket,
          sanbox: this.isSanboxMode
        }
      ).then((response) => {
        console.log('basket response', response)
        if (response.data) {
          this.$set(this.basket, 'id', response.data.id)
          this.basketLines = response.data.lines.data
        }
      })
    },
    createBasketLine (basketId, variants) {
      axios.post(`${process.env.OLD_ECOMMERCE_URL}/basket-lines`, {variants, basket_id: basketId}).then((response) => {
        if (response && response.data) {
          this.basketLines = response.data.lines.data
        }
      })
    },
    updateBasketLine (quantity, variantId) {
      if (quantity === 0) {
        this.$confirm(this.$t('Do you want to remove product from the order?'), this.$t('Remove product'), {
          confirmButtonText: this.$t('Yes'),
          cancelButtonText: this.$t('Cancel')
        }).then(() => {
          let basketLine = this.basketLines.find((item) => item.variant.data.id === variantId)
          if (basketLine) {
            this.removeBasketLine(basketLine.id)
          }
          let existIndex = this.orders.findIndex((item) => item.variant.id === variantId)
          console.log('existIndex', existIndex)
          if (existIndex !== -1) {
            this.orders.splice(existIndex, 1)
          }
        }).catch(() => {
          let exist = this.orders.find((item) => item.variant.id === variantId)
          this.$set(exist, 'quantity', 1)
        })
      } else {
        // update basket line
        let basketLine = this.basketLines.find((item) => item.variant.data.id === variantId)
        if (basketLine) {
          axios.put(`${process.env.OLD_ECOMMERCE_URL}/basket-lines/${basketLine.id}`, {quantity}).then((response) => {
            console.log('update basket-line response', response)
            if (response && response.data) {
              this.basketLines = response.data.lines.data
            }
          })
        }
      }
    },
    removeBasketLine (basketLineId) {
      axios.delete(`${process.env.OLD_ECOMMERCE_URL}/basket-lines/${basketLineId}`)
    },
    productNumberUp (orderLine) {
      this.changeProductNumber(orderLine)
    },
    productNumberDown (orderLine) {
      this.$set(orderLine, 'quantity', orderLine.quantity - 1)
      this.updateBasketLine(orderLine.quantity, orderLine.variant.id)
      this.updateVariantInventory(orderLine.variant.id, 1)
    },
    async changeProductNumber (orderLine) {
      this.$set(orderLine.variant, 'inventory_checking', true)
      let available = await this.checkVariantInventory({variantId: orderLine.variant.id, quantity: orderLine.quantity})
      this.$set(orderLine.variant, 'inventory_checking', false)
      if (available) {
        this.$set(orderLine, 'quantity', orderLine.quantity + 1)
        this.updateBasketLine(orderLine.quantity, orderLine.variant.id)
        this.updateVariantInventory(orderLine.variant.id, -1)
      } else {
        this.$notify({
          type: 'warning',
          title: 'Insufficient quantity in stock',
          message: 'Someone just picked some of this'
        })
      }
    },
    removeBasket () {
      if (this.basket.id) {
        axios.delete(`${process.env.OLD_ECOMMERCE_URL}/baskets/${this.basket.id}`)
          .then((response) => {
            console.log('removeBasket', response)
          })
      }
    },
    showConfirmOrder () {
      this.$emit('openConfirm')
      this.$confirm(this.$t('Do you want to confirm this order?'), this.$t('Order confirmation'), {
        confirmButtonText: this.$t('Yes'),
        cancelButtonText: this.$t('Cancel'),
        message: this.$t(
          'The number of the articles is x. The total amount is y',
          {totalNumber: this.totalNumber, totalAmount: Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(this.totalAmount)}
        )
      }).then(() => {
        this.$emit('orderConfirmed')
        this.submitOrder()
      }).catch(() => {
        this.$emit('closeConfirm')
      })
    },
    showConfirmCancellation () {
      this.$confirm(
        this.$t('Do you want to cancel this shopping cart? All the selected products will be put back in the inventory.'),
        this.$t('Shopping cart cancellation'),
        {
          confirmButtonText: this.$t('Yes'),
          cancelButtonText: this.$t('Cancel')
        }).then(() => {
        this.resetCart(true)
      }).catch(() => {
      })
    },
    resetCart (backInventory = false) {
      if (backInventory) {
        this.removeBasket()
      }
      setTimeout(() => {
        this.orders = []
        this.basket = {
          variants: []
        }
        this.basketLines = []
      }, 100)
    },
    submitOrder () {
      if (this.basket.id) {
        this.orderSending = true
        axios.post(`${process.env.OLD_ECOMMERCE_URL}/orders`, { basket_id: this.basket.id })
          .then((response) => {
            this.orderSending = false
            if (response && response.data) {
              let order_products = []
              let order_quatity_lines = []
              response.data.lines.data.forEach((line) => {
                order_products.push(line.variant.data.product.data.sku)
                order_quatity_lines.push(line.quantity)
              })
              window.analytics.track('p-vtRalphLaurenJapanEcomOrderReport',
                {
                  userid: this.sa.id,
                  vtid: this.projectId,
                  vturl: window.location.href,
                  items: this.totalNumber,
                  subTotal: response.data.sub_total,
                  taxTotal: response.data.tax_total,
                  totalAmount: response.data.order_total,
                  datetime: response.data.created_at,
                  VIPid: this.userConnected.username || this.userConnected.email,
                  SAid: this.sa.username || this.sa.email,
                  SAstore: this.sa.store_id || 1,
                  SAstoreemail: (this.sa.store || {}).email,
                  RLopsemail: '',
                  display_id: response.data.display_id,
                  products: order_products,
                  quantities: order_quatity_lines,
                  sanbox: this.isSanboxMode
                }
              )
              setTimeout(() => {
                this.resetCart()
              }, 300)
            } else {
              this.$notify({
                type: 'error',
                message: this.$t('Something wrong! Please try later.')
              })
            }
          })
      }
    },
    updateVariantInventory (variantId, inventory) {
      console.log('updateVariantInventory', variantId, inventory)
      if (!this.isSanboxMode) {
        this.changeVariantInventory({variant_id: variantId, number: inventory})
        axios.put(`${process.env.OLD_ECOMMERCE_URL}/products/variants/${variantId}/inventory_cart`, {inventory})
          .then((response) => {
            console.log('updateVariantInventory response', response)
          })
      }
    },
    fetchOldBasket () {
      console.log('fetchOldBasket', this.projectId, this.userConnected)
      if (this.projectId && this.userConnected && (this.userConnected.username || this.userConnected.email)) {
        this.cartFetching = true
        this.resetCart()
        axios.get(`${process.env.OLD_ECOMMERCE_URL}/baskets/sa?assets,variants`, {
          params: {project_id: this.projectId, username: this.userConnected.username || this.userConnected.email}
        })
          .then((response) => {
            console.log('fetchOldBasket', response)
            this.cartFetching = false
            if (response && response.data && response.data.length) {
              let basket = response.data[0]
              this.basketLines = basket.lines.data
              basket.lines.data.forEach((line) => {
                this.basket.id = basket.id
                this.basket.variants.push({
                  quantity: line.quantity,
                  id: line.variant.id
                })
                this.orders.push({
                  quantity: line.quantity,
                  variant: line.variant.data
                })
              })
            }
          })
      }
    }
  },
  created () {
    this.$on('addProduct', (data) => {
      this.addProduct(data)
      this.updateBasket(data)
    })
    this.$on('removeProduct', (data) => {
      this.removeProduct(data)
    })
    this.$on('removeAllProducts', () => {
      this.orders = []
    })
    this.$on('clearCart', () => {
      this.resetCart(true)
    })
    this.$on('fetchCart', () => {
      setTimeout(() => {
        this.fetchOldBasket()
      }, 300)
    })
  },
  watch: {
    orders: {
      deep: true,
      handler: function (newOrders) {
        this.totalNumber = 0
        this.totalAmount = 0
        this.orders.forEach((order, index) => {
          this.totalNumber = this.totalNumber + order.quantity
          this.totalAmount = this.totalAmount + order.quantity * order.variant.price
        })
        this.$emit('changeAmount', this.totalNumber)
      }
    },
    userConnected () {
      this.fetchOldBasket()
    }
  }
}
</script>
<style scoped>
.product-list {
  max-height: calc(100vh - 280px);
  overflow: auto;
}
.product-item {
  border-bottom: 1px solid #ddd;
}
.product-item:last-child {
  border-bottom: none;
}
.product-item img {
  width: 100px;
  height: 80px;
  object-fit: contain;
}
.text-capitalize {
  text-transform: capitalize;
}
.total-money {
  height: 26px;
  line-height: 26px;
  width: 160px;
  border-radius: 4px;
  border: 1px solid #ddd;
  padding: 0px 4px;
}
</style>
<style>
.input-number-custom .el-input__inner {
  text-align: center !important;
  background-color: initial !important;
  border-color: #dcdfe6 !important;
  color: initial !important;
  cursor: initial !important;
}
</style>



// WEBPACK FOOTER //
// src/components/preview/Cart.vue